<template>
  <b-modal
    id="refund-Remitter-credit"
    size="lg"
    title="Refund"
    no-stacking
    no-close-on-backdrop
    hide-footer
  >
    <div class="modal-area">
      <ValidationObserver v-slot="{ passes }">
        <form @submit.prevent="passes(editremitterCredit)" id="basic-form">
          <ValidationProvider
            name="refund_type"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="country-dropdown">
              <div
                class="form-group form-select multiselect-grp"
                :class="{
                  errors: errors[0],
                  success:
                    remitterCredit.refundType &&
                    remitterCredit.refundType.length != 0 &&
                    !errors[0],
                }"
              >
                <span class="float-label">
                  <label for="refund_type">Select Refund Type*</label>
                  <multiselect
                    placeholder=""
                    v-model="remitterCredit.refundType"
                    :show-labels="false"
                    :options="refund_type_Options"
                    :searchable="false"
                    @select="changeCreditOptions"
                  ></multiselect>
                  <i class="fa fa-times" v-if="errors.length && errors[0]"></i>
                  <i
                    class="fa fa-check"
                    v-if="
                      remitterCredit.refundType &&
                      remitterCredit.refundType.length != 0 &&
                      !errors[0]
                    "
                  ></i>
                </span>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="customer"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="country-dropdown">
              <div
                class="form-group form-select multiselect-grp"
                :class="{
                  errors: errors.length && !remitterCredit.customer,
                  success: remitterCredit.customer,
                }"
              >
                <span class="float-label">
                  <label for="customer">Select Customer</label>
                  <v-select
                    :options="customersoptions"
                    multiple
                    v-model="remitterCredit.customer"
                    disabled
                  ></v-select>
                  <div class="line"></div>
                  <i
                    class="fa fa-times"
                    v-if="errors.length && !remitterCredit.customer"
                  ></i>
                  <i class="fa fa-check" v-if="remitterCredit.customer"></i>
                </span>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="amount"
            rules="required"
            v-slot="{ errors }"
          >
            <div
              class="form-group"
              :class="{
                errors: errors.length && !remitterCredit.amount,
                success: remitterCredit.amount,
              }"
            >
              <span class="float-label">
                <input
                  type="text"
                  v-model="remitterCredit.amount"
                  class="form-control"
                  id="amount"
                  placeholder="Company Name*"
                  disabled
                />
                <label for="amount" class="control-label">
                  Amount added in Wallet*
                </label>
                <div class="line"></div>
                <i
                  class="fa fa-times"
                  v-if="errors.length && !remitterCredit.amount"
                ></i>
                <i class="fa fa-check" v-if="remitterCredit.amount"></i>
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="credit_type"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="country-dropdown">
              <div
                class="form-group form-select multiselect-grp"
                :class="{
                  errors: errors[0],
                  success:
                    remitterCredit.creditType &&
                    remitterCredit.creditType.length != 0 &&
                    !errors[0],
                }"
              >
                <span class="float-label">
                  <label for="credit_type">Select Credit Type*</label>
                  <multiselect
                    placeholder=""
                    v-model="remitterCredit.creditType"
                    :show-labels="false"
                    :options="creditType_Options"
                    :searchable="false"
                    :disabled="remitterCredit.refundType == 'E-Wallet'"
                  ></multiselect>
                  <i class="fa fa-times" v-if="errors.length && errors[0]"></i>
                  <i
                    class="fa fa-check"
                    v-if="
                      remitterCredit.creditType &&
                      remitterCredit.creditType.length != 0 &&
                      !errors[0]
                    "
                  ></i>
                </span>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="comment"
            rules="required"
            v-slot="{ errors }"
          >
            <div
              class="form-group"
              :class="{
                errors: errors.length && !remitterCredit.comment,
                success: remitterCredit.comment,
              }"
            >
              <span class="float-label">
                <textarea
                  type="text"
                  v-model="remitterCredit.comment"
                  class="form-control"
                  id="comment"
                  placeholder="Company Name*"
                ></textarea>
                <label for="comment" class="control-label">Comment*</label>
                <div class="line"></div>
                <i
                  class="fa fa-times"
                  v-if="errors.length && !remitterCredit.comment"
                ></i>
                <i class="fa fa-check" v-if="remitterCredit.comment"></i>
              </span>
            </div>
          </ValidationProvider>
          <div class="row">
            <div
              class="col-6 d-flex justify-content-between align-items-center m-b-20"
            >
              <label class="mb-0" for="customSwitchCancel">
                Cancel the Transaction ?
              </label>
              <div class="custom-switch success-error-bg">
                <input
                  type="checkbox"
                  class="custom-switch-input"
                  id="customSwitchCancel"
                  v-model="cancelTransaction"
                />
                <label class="custom-switch-label" for="customSwitchCancel">
                  <span class="custom-switch-text1">Yes</span>
                  <span class="custom-switch-text2">No</span>
                </label>
              </div>
            </div>
            <div
              class="col-6 d-flex justify-content-between align-items-center m-b-20"
            >
              <label class="mb-0" for="customSwitchemail">
                Send Notification to Customer?
              </label>
              <div class="custom-switch success-error-bg">
                <input
                  type="checkbox"
                  class="custom-switch-input"
                  id="customSwitchemail"
                  v-model="sendNotification"
                />
                <label class="custom-switch-label" for="customSwitchemail">
                  <span class="custom-switch-text1">Yes</span>
                  <span class="custom-switch-text2">No</span>
                </label>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column flex-md-row justify-content-center">
            <b-button
              variant="secondary btn-mw"
              size="lg"
              @click="cancelEdit()"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
              size="lg"
            >
              Submit
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "vue-select/dist/vue-select.css";
export default {
  name: "RefundRemitterCredit",
  components: {
    Multiselect: () => import("vue-multiselect"),
    "v-select": () => import("vue-select"),
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    remitterCredit: Object,
  },
  data() {
    return {
      sendNotification: false,
      cancelTransaction: true,
      customersoptions: [
        "Adam Driver",
        "Dominic Torreto",
        "Brain O'Conner",
        "Mark Chalamet",
        "Robert Evans",
        "Emma Thomas",
        "Alizee Thomas",
        "Selena Parker",
        "Hal Chalamet",
        "Ben Murphy",
      ],
      creditType_Options: ["Checkout", "Clear Junction"],
      refund_type_Options: ["Orignal Method", "E-Wallet"],
    };
  },
  methods: {
    editremitterCredit() {
      console.log(this.remitterCredit);
      this.$bvModal.hide("refund-Remitter-credit");
    },
    changeCreditOptions(event) {
      if (event == "E-Wallet") {
        this.remitterCredit.creditType = "Refund";
      } else {
        this.remitterCredit.creditType = "";
      }
    },
    cancelEdit() {
      this.$bvModal.hide("refund-Remitter-credit");
    },
  },
};
</script>
